// Open House events for the app's Google tag (GTM-P56WM6W, production only),
// through window.dataLayer. Every push carries every key, null when it does not
// apply, because GTM keeps a key's last value across pushes. Never a name, an
// email or anything the guest typed.

const KEYS = { service: null, step: null, step_number: null, value: null, currency: null, transaction_id: null }

export function track(event, params = {}) {
  window.dataLayer?.push({ event, ...KEYS, ...params })
}

// For an event right before the page leaves: `next` runs once GTM has sent it,
// or after a short wait when GTM never answers (no tag loaded, blocked).
export function trackThen(event, params, next) {
  if (!window.dataLayer) return next()
  let done = false
  const go = () => {
    if (done) return
    done = true
    next()
  }
  track(event, { ...params, eventCallback: go, eventTimeout: 1500 })
  window.setTimeout(go, 2000)
}

// The one "project posted" event, from the confirmation that published the
// project (the server's `posted`: service, accepted price, order number).
export function postedThen(posted, next) {
  if (!posted) return next()
  trackThen("project_posted", {
    service: posted.service, value: posted.value, currency: posted.currency, transaction_id: posted.order,
  }, next)
}
